module.exports = __webpack_public_path__ + "img/mita_yes.cebd0446.png";